import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import MaterialUsage37_1Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const MaterialUsage37_1 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("MATERIAL_USAGE") || "Material Usage"}
        subDescription={t("MATERIAL_USAGE_37_1_DESC") || "List all materials used during construction and installation, including water and other resources. This includes materials consumed during installation that aren't part of the final product, but are required for installation, such as protective plastic sheeting (if not reused) and pallets returned to the supplier. Further down, list waste as surplus materials."}
        isNormal={true}
        number={"37.1"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`material-usage-37-1-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <MaterialUsage37_1Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default MaterialUsage37_1;

